import { startOfWeek, endOfWeek, eachDayOfInterval } from 'date-fns';

const getWeekDays = (date: Date) => {
  const weekStart = startOfWeek(date, { weekStartsOn: 1 });
  const weekEnd = endOfWeek(date, { weekStartsOn: 1 });
  const weekDays = eachDayOfInterval({
    start: weekStart,
    end: weekEnd,
  });
  return weekDays;
};

const getWeekRange = (date: Date) => {
  return {
    from: startOfWeek(date, { weekStartsOn: 1 }),
    to: endOfWeek(date, { weekStartsOn: 1 }),
  };
};

export { getWeekDays, getWeekRange };
